import { handleActions } from 'redux-actions';
import { ENV_DEFAULT_OPTION_SUBSCRIPTION, STACK_DEFAULT_OPTION } from '../../../shared/constants/matrixOptions';
import {
  setStackSelection,
  setStackAccount,
  setSearchTextGlobal,
  setCurrentTabState,
  setSearchTextGlobalSubsId,
  setDeleteOrderLoader,
} from './actions';

const defaultState = {
  stackSelection: STACK_DEFAULT_OPTION.prod,
  selectedAccount: ENV_DEFAULT_OPTION_SUBSCRIPTION,
  searchTextSubscription: '',
  currentTabState: 'showOrder',
  searchTextGlobalSubsId: '',
  orderDeleted: false,
};

const orderOperations = handleActions(
  {
    [setStackSelection]: (state, { payload }) => ({
      ...state,
      stackSelection: payload,
      isError: false,
    }),
    [setStackAccount]: (state, { payload }) => ({
      ...state,
      selectedAccount: payload,
      isError: false,
    }),
    [setSearchTextGlobal]: (state, { payload }) => ({
      ...state,
      searchTextSubscription: payload,
    }),
    [setCurrentTabState]: (state, { payload }) => ({
      ...state,
      currentTabState: payload,
    }),
    [setSearchTextGlobalSubsId]: (state, { payload }) => ({
      ...state,
      searchTextGlobalSubsId: payload,
    }),
    [setDeleteOrderLoader]: (state, { payload }) => ({
      ...state,
      orderDeleted: payload,
    }),
  },
  defaultState
);

export default orderOperations;
